import React from 'react';
import { TextField, TextFieldProps } from 'formik-mui';
import FieldFrame from './FieldFrame';
import { outlinedFieldSx } from './styles';

const LabeledTextField = (props: TextFieldProps) => {
  const { label, sx, field, fullWidth = true, ...rest } = props;
  const inputId = field?.name ? `${field.name}-input` : undefined;

  return (
    <FieldFrame label={label} htmlFor={inputId}>
      <TextField
        {...rest}
        field={field}
        id={inputId}
        fullWidth={fullWidth}
        sx={{ ...outlinedFieldSx, ...sx }}
        label={undefined}
      />
    </FieldFrame>
  );
};

export default LabeledTextField;
